import { getJson, postJson, putJson, deleteJson, withDone, withValidate } from '@rad/utility/http';
export const getPropertyTags = () => getJson('/api/property-tags');
export const getIcons = () => getJson('/api/parcel-kinds/icons');
export const createPropertyTag = (form) => withDone(withValidate(postJson('/api/property-tags', form)))();
export const updatePropertyTag = (id, form) => withDone(withValidate(putJson(`/api/property-tags/${id}`, form)))();
export const deletePropertyTag = (id) => withDone(deleteJson(`/api/property-tags/${id}`))();
